import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import MessageGrid from '../../purchaseRequisition/messageGrid';
import ApiService from '../../../services/apiService';
import ItemGridGRN from './itemGrid';
import { toast } from 'react-toastify';
import AuthorizationGrn from '../authorization';
import { useLocation, useNavigate } from 'react-router-dom';
import UpdateItemGridGRN from './updateitemgrid';
import { useSelector } from 'react-redux';
import { getName } from '../../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaSave } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa6";
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';
import moment from 'moment';
import UpdateAttachment from '../../Attachment/UpdateAttachment';



const createEmptyRow = () => ({
    id: Date.now() + Math.random(),
    file: null,
    fileName: "",
    remarks: "",
});
const REPORT_URL = process.env.REACT_APP_REPORTS_URL


const UpdateGrn = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new ApiService();
    const [messageData, setMessageData] = useState([]);
    const [authorizationData, setAuthorizationData] = useState([]);
    const [ItemData, setItemData] = useState([]);
    const [POData, setPOData] = useState([]);
    const { currencyPrecision } = useCurrency();
    const [selectedPOData, setSelectedPOData] = useState([]);
    const [supplier, setSupplier] = useState([]);
    const [usersDetails, setUser] = useState([]);
    const [Department, setDepartment] = useState([]);
    const [WareHouse, setWareHouse] = useState([]);
    const [selectedWareHouse, setSelectedWareHouse] = useState([]);
    const [PurchaseOrder, setPurchaseOrder] = useState([]);
    const [SelectedPO, setSelectedPO] = useState([]);
    const [SelectedSupplier, setSelectedSupplier] = useState([]);
    const [SelectedCurrency, setSelectedCurency] = useState([]);
    const [currency, setCurrency] = useState([]);
    const location = useLocation();
    const [grnNo, setGrnNumber] = useState([]);
    const navigate = useNavigate();
    const userName = useSelector(getName);
    const itemData = location.state;
    const [PurchaseTab, setPurchaseTab] = useState(true);
    const [loader, setLoader] = useState(false);
    const [CostTab, setCostTab] = useState(true);
    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);
    const [preview, setPreview] = useState();
    const [attachments, setAttachments] = useState([createEmptyRow()]);
    const closeModal = () => setAttachmentModal(false);

    const formatDateToDatetimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    const getCurrentLocalDatetime = () => {
        const localDate = new Date();
        const offset = localDate.getTimezoneOffset() * 60000;
        const localISOTime = new Date(localDate - offset).toISOString().slice(0, 16);
        return localISOTime;
    };
    useEffect(() => {
        fetchData()
        getApprovalUser()
        getCurrency()
    }, [])
    const fetchData = async () => {
        const item = location.state;
        let PO = await apiService.get('GET_PO_LIST');

        const uniqueResult = PO?.data?.result.filter(
            (item, index, self) =>
                index === self.findIndex(
                    t => t.pOrderNo === item.pOrderNo
                )
        );

        setPurchaseOrder(uniqueResult);
        const Supplier = await apiService.get("GET_SUPPLIER");
        setSupplier(Supplier?.data?.result);
        const department = await apiService.get("GET_DEPARTMENT_MASTER");
        setDepartment(department?.data?.result);
        // let wareparam = `?Exp3=1`
        let WareHouse = await apiService.get('GET_WAREHOUSE_MASTER')
        setWareHouse(WareHouse?.data?.result);
        let poParam = `?id=${itemData?.pOrderNo}`;
        const PurchaseOrdera = await apiService.getApiParamater("GET_PO", poParam);
        const selectedOption = PurchaseOrdera?.data?.result?.[0];
        const selectedLoc = WareHouse?.data?.result?.find(war => war?.description === item?.warehouse);
        setSelectedPO({ label: selectedOption?.pOrderNo, value: selectedOption })
        setSelectedSupplier({ label: selectedOption?.vendorName, value: selectedOption })
        setSelectedPOData(selectedOption)
        setPOData(item?.grnDetails)
        setSelectedWareHouse({ label: selectedLoc?.description, value: selectedLoc })
        const formattedPODate = selectedOption?.docDate ? formatDateToDatetimeLocal(selectedOption?.docDate) : getCurrentLocalDatetime();
        const formattedInvDate = item?.invoiceDate ? formatDateToDatetimeLocal(item?.invoiceDate) : getCurrentLocalDatetime();
        const formattedDelivDate = item?.delivery_Date ? formatDateToDatetimeLocal(item?.delivery_Date) : getCurrentLocalDatetime();
        setFormData({
            GRNNO: item?.grnNo,
            remarks: item?.remarks,
            InvoiceNo: item?.invoiceNo,
            InvoiceDate: formattedInvDate,
            deliveryDate: formattedDelivDate,
            Department: item?.department,
            PurchaseOrderDate: formattedPODate,
            deliveryNote: item?.invoiceRef
        });
        setGrnNumber(item?.grnNo)

        let attachparam = `?DocNo=${itemData?.grnNo}&DocType=${"GRN"}`;
        const AttachmentResponse = await apiService.getApiParamater("GET_ATTACHMENT", attachparam);
        const existingAttachments = AttachmentResponse?.data?.result || [];
        if (existingAttachments) {
            setAttachments(mapAttachmentsFromApi(existingAttachments));
        }
    }
    const mapAttachmentsFromApi = (apiData) => {
        const validFiles = apiData.filter(
            a => a.fileName && a.fileName.trim() !== ""
        );

        return [
            ...validFiles.map(item => ({
                id: Date.now() + Math.random(), // UI id
                dbId: item.rcno,                // backend id
                file: null,                     // existing file (no File object)
                fileName: item.fileName,
                remarks: item.remarks || "",
                isNew: false,
                isDeleted: false,
            })),
            createEmptyRow()
        ];
    };
    const getApprovalUser = async () => {
        try {
            let param = `?DocType=GRN`;
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('DocNo', itemData?.grnNo);
            params.append('DocumentType', "GRN");
            const response = await apiService.getApiParamater('GET_DOC_STATUS_EDIT', `?${params.toString()}`);
            setUser(response.data.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
        setGridVisibility(newGridVisibility);
    };
    const handleMessage = (data) => {
        setMessageData(data);
        console.log(data, 'reqData')

    };
    const handleRequisitionData = (data) => {
        setItemData(data);
        console.log(data, 'reqData')
    };
    const handleAuthorization = (data) => {
        setAuthorizationData(data);
        console.log(data, 'reqData')
    };
    const [formData, setFormData] = useState({
        GRNNO: "",
        deliveryNote: "",
        remarks: "",
        InvoiceNo: "",
        InvoiceDate: "",
        deliveryDate: "",
        PropertyGroup: "",
        TaxInvoice: "",
        Property: "",
        Department: "",
        Outlet: "",
        Currency: "",
        exchangeRate: "",
        deliveryPoint: "",
        PurchaseOrderDate: "",
        contactPerson: "",
        contatNo: "",
        taskCode: "",
        email: '',
        subcatname: "",
        location: []
    });
    const staticOptions = [];
    const handlePoChange = (selectedOption) => {
        setSelectedPO(selectedOption);
        setSelectedSupplier({ label: selectedOption.value.vendorName, value: selectedOption?.value })
        let docDateUTC = new Date(selectedOption.value.docDate);
        let localDateString = new Date(docDateUTC.getTime() - (docDateUTC.getTimezoneOffset() * 60000))
            .toISOString()
            .slice(0, 16);

        setFormData({ ...formData, PurchaseOrderDate: localDateString });
        setSelectedPOData(selectedOption.value)
        // fetchPOData(selectedOption)
        setPOData(selectedOption.value?.poDetails)
    };
    const handleDepartmentChange = (selectedOption) => {
        setFormData({ ...formData, Department: selectedOption?.description });
    }
    const handleLocationChange = (selectedOption) => {
        setSelectedWareHouse(selectedOption)
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'deliveryDate' || name === 'PurchaseOrderDate' || name === 'InvoiceDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const UpdateGRN = async () => {
        setLoader(true)
        if (ItemData.length === 0) {
            toast.warning("Please add items");
            setLoader(false)
            return;
        }
        if (!selectedWareHouse?.label) {
            toast.warning("Select Location")
            setLoader(false)
            return
        }
        if (!formData?.deliveryDate) {
            toast.warning("Select Delivery Date")
            setLoader(false)
            return
        }
        if (!formData?.InvoiceDate) {
            toast.warning("Select Invoice Date")
            setLoader(false)
            return
        }
        const hasBaseQty = ItemData.some(item => item.baseQty > 0);
        if (!hasBaseQty) {
            toast.warning("At least one item must have a base quantity greater than zero.");
            setLoader(false);
            return;
        }

        const missingGL = ItemData.find(item => !item.inventoryAccountCode);
        if (missingGL) {
            toast.warning(`Please Add GL Accounts for ${missingGL?.itemDescription}`);
            setLoader(false)
            return;
        }
        const missingGRNAcc = ItemData.find(item => !item.GRNAccountCode);
        if (missingGRNAcc) {

            toast.warning(`Please Add GL Accounts for ${missingGRNAcc?.itemDescription}`);
            setLoader(false)
            return;
        }
        try {

            const totalAmount = ItemData.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
            const vatAmount = ItemData.reduce((sum, row) => sum + (parseFloat(row.vatAmount) || 0), 0);
            const GrossAmount = parseFloat(totalAmount || 0) - parseFloat(vatAmount || 0);
            const currentDatetimeUTC = new Date().toISOString();
            const apiService = new ApiService()
            const GRNDetailsData = ItemData.map((item, index) => {
                const grossAmount = parseFloat(item.amount) - parseFloat(item.vatAmount || 0);
                let vatunitPrice = item.vatAmount / item.qty;
                if (item?.batchNo) {
                    if (!item?.expDate) {
                        toast.warning(`Please Select Exp Date of ${item.itemDescription}`)
                        setLoader(false)
                        return
                    }
                }
                if (item?.expDate) {
                    if (!item?.batchNo) {
                        toast.warning(`Please Enter Batch No of ${item.itemDescription}`)
                        setLoader(false)
                        return
                    }
                }
                return {
                    requisitionNo: item?.requisitionNo,
                    srno: index + 1,
                    itemCode: item?.ItemNo,
                    itemDescription: item.itemDescription,
                    uom: item.uom,
                    qty: parseFloat(item.qty || 0),
                    baseUOM: item?.uom,
                    baseQty: parseFloat(item.baseQty),
                    specification: item.specification,
                    convValue: parseFloat(item?.convValue),
                    unitPrice: parseFloat(item.baseAmount),
                    amount: parseFloat(item.amount),
                    baseAmount: parseFloat(item.amount - item?.vatAmount),
                    convToInvUOM: parseFloat(item.convValue),
                    // convToInvUOM: 1,
                    importedQty: 0,
                    vatPerc: item.vat,
                    extraQty: 0,
                    vatAmount: parseFloat(item.vatAmount),
                    prodDate: getCurrentLocalDatetime(),
                    expDate: item.expDate,
                    batchNo: item.batchNo,
                    isActive: true,
                    grnNo: grnNo,
                    returnQty: 0,
                    invoicedQty: 0,
                    vatCode: 1,
                    vatDesc: item.vatDes,
                    vatUnitPrice: parseFloat(item.vatAmount / item.qty),
                    vatBaseAmount: parseFloat(item.vatAmount),
                    vatInclusive: selectedPOData.costCenter5 === "Included" ? false : true,
                    grossAmount: 0,
                    addCharges: 0,
                };
            });
            const userData = {
                grnNo: itemData.grnNo,
                pOrderNo: selectedPOData?.pOrderNo,
                delivery_Date: selectedPOData?.deliveryDate || formData.InvoiceDate,
                status: 0,
                remarks: formData?.remarks,
                modifiedOn: getCurrentLocalDatetime(),
                modifiedBy: userName,
                terms: selectedPOData.terms,
                vendorId: SelectedSupplier?.value?.vendorId,
                vendorName: SelectedSupplier?.label,
                department: "IT",
                // department: formData?.Department,
                costCenter2: selectedPOData?.costCenter2,
                costCenter3: selectedPOData?.costCenter3,
                costCenter4: selectedPOData?.costCenter4,
                isActive: true,
                grnDetailsDtos: GRNDetailsData,
                warehouse: selectedWareHouse?.label,
                poType: "GRN",
                invoiceNo: formData.InvoiceNo,
                invoiceDate: formData.InvoiceDate,
                invoiceRef: formData.deliveryNote,
                currencyCode: SelectedCurrency?.label,
                exchangeRate: SelectedCurrency?.value.conversionRate,
                baseAmount: totalAmount.toFixed(currencyPrecision?.exp1 || 3),
                amount: totalAmount.toFixed(currencyPrecision?.exp1 || 3),
                grossAmount: GrossAmount.toFixed(currencyPrecision?.exp1 || 3),
                grossBaseAmount: GrossAmount.toFixed(currencyPrecision?.exp1 || 3),
                transport_Mode: "From PO",
                vatInclusive: selectedPOData?.costCenter5 === "Included" ? false : true,
            };
            debugger
            const response = await apiService.put("UPDATE_GRN", userData);
            if (response?.data?.statusCode === 201) {
                const userData2 = {
                    docType: "GRN",
                    docId: grnNo,
                    status: 0,
                    remarks: formData?.remarks,
                };
                if (attachments) {
                    let name = "GRN"
                    let docNo = grnNo
                    handleUpload(name, docNo)
                }
                const response2 = await apiService.put("UPDATE_DOC_AUTHORIZATION_STATUS", userData2);
                const paramsGet = new URLSearchParams();
                paramsGet.append('docType', "GRN");
                paramsGet.append('docId', grnNo);
                paramsGet.append('srno', 1);
                const response3 = await apiService.getApiParamater('GET_DOC_APPROVAL_USER', `?${paramsGet.toString()}`);
                if (response3?.data?.result.length > 0) {
                    const toEmails = response3?.data?.result?.map(user => user.userEmail);
                    const emailbody = {
                        toEmails: toEmails,
                        subject: "GRN",
                        body: "",
                        docNo: grnNo,
                        srNo: 1,
                        docType: "GRN"
                    };
                    const emailres = await apiService.post("DOC_APPROVAL_EMAIL_POST", emailbody);
                }
                const token = localStorage.getItem("Token");
                const DB = localStorage.getItem("DataBase")
                if (!token) {
                    alert("Auth token is missing! Unable to proceed.");
                    return;
                }
                const popupWidth = 1000;
                const popupHeight = 600;
                const popupLeft = (window.screen.width - popupWidth) / 2;
                const popupTop = (window.screen.height - popupHeight) / 2;
                const popup = window.open(
                    "",
                    "ReportPopup",
                    `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
                );

                if (popup) {
                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = REPORT_URL;
                    form.target = "ReportPopup";

                    const inputs = [
                        { name: "authToken", value: token },
                        { name: "_db", value: DB },
                        { name: "reportName", value: "GRN" },
                        { name: "voucherNo", value: grnNo },
                    ];

                    inputs.forEach(({ name, value }) => {
                        const input = document.createElement("input");
                        input.type = "hidden";
                        input.name = name;
                        input.value = value;
                        form.appendChild(input);
                    });

                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                toast.success(`${itemData.grnNo} Updated successfully`);
                setLoader(false)
                navigate("/Inventory/GRN/Listing")
            }
        } catch (error) {
            setLoader(false)
            console.error("Error Creating PR:", error);
        }
    };
    const getCurrency = async () => {
        setFormData({ ...formData, exchangeRate: currencyPrecision.conversionRate });
        if (currencyPrecision) {
            setSelectedCurency({ label: currencyPrecision.code, value: currencyPrecision });
        }
    }
    const handleBackClick = () => {
        window.history.back();
    }
    const handleReset = () => {
        setFormData({
            GRNNO: "",
            deliveryNote: "",
            remarks: "",
            InvoiceNo: "",
            InvoiceDate: getCurrentLocalDatetime(),
            deliveryDate: getCurrentLocalDatetime(),
            TaxInvoice: "",
            costCenter1: "",
            costCenter2: "",
            costCenter3: "",
            costCenter4: "",
            Currency: "",
            exchangeRate: "",
            deliveryPoint: "",
            PurchaseOrderDate: "",
            contactPerson: "",
            contatNo: "",
            taskCode: "",
            email: '',
            subcatname: "",
            location: []
        });
    }
    const DeliveryType = [
        { value: 'E-Ticket', label: 'E-Ticket' },
        { value: 'Hand Delivery', label: 'Hand Delivery' },
    ];

    // Attachment Functions
    const handleFileSelect = (file, id) => {
        setAttachments(prev => {
            const updated = prev.map(row =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    };
    const handleRemarkChange = (id, value) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = (id) => {
        setAttachments(prev =>
            prev.map(row =>
                row.id === id
                    ? { ...row, isDeleted: true }
                    : row
            )
        );
    }
    const handleView = (file) => {
        if (!file) return;
        if (file?.isNew === false) {
            setPreviewImage(file?.fileName);
        } else {
            setPreviewImage(URL.createObjectURL(file?.file));
        }
        setPreview(file)
        setPreviewModal(true);
    };
    const handleUpload = async (name, docNo) => {
        const formData = new FormData();
        attachments.forEach(({ file }) => {
            if (file instanceof File) {
                formData.append("Images", file, file.name);
            }
        });

        const response = await apiService.postMultiPart(
            "UPLOAD_FILE",
            formData
        );

        if (response?.data?.statusCode === 201 && response?.data?.isSuccessful) {

            const uploadedFileNames = response.data.result.split(",");
            let uploadedIndex = 0;

            const payload = {
                docFilesDtos: attachments
                    .filter(a => {
                        //  skip deleted
                        if (a.isDeleted === true) return false;

                        //  keep old files
                        if (a.fileName && a.fileName.trim()) return true;

                        //  keep new uploads only if file exists
                        if (a.isNew && a.file) return true;

                        //  skip empty rows
                        return false;
                    })
                    .map((a, index) => {

                        let fileName = a.fileName?.trim();

                        // 🔁 Assign uploaded filename ONLY to new attachments
                        if (!fileName && a.isNew) {
                            fileName = uploadedFileNames[uploadedIndex]?.trim();
                            uploadedIndex++;
                        }
                        return {
                            rcno: a?.dbId,
                            srno: index + 1,
                            docNo: docNo,
                            docType: name,
                            fileName,
                            remarks: a.remarks || "",
                        };
                    }),
                docNo: docNo,
            };

            await apiService.put("UPDATE_ATTACHMENT", payload);
        }

    };
    return (
        <div className='p-5'>
            <div className='d-flex justify-contant-between '>
                <h5 className='col mainInvHead'>Goods Receipt Note</h5>
                <div className='d-flex justify-content-end gap-1'>
                    <div className='col center'>
                        {itemData?.eye === true ? " " :
                            <>
                                {loader === true ?
                                    <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                    <button className='mainbtn ' onClick={UpdateGRN} type="submit">
                                        <FaSave className='center mt-1 mx-2' /> <div>Update</div>
                                    </button>
                                }
                            </>}
                    </div>
                    {itemData?.eye === true ? " " :
                        <button className='mainbtnRed' onClick={() => handleReset()}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>}
                    <button onClick={handleBackClick} className='mainbtnSecondary'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setPurchaseTab(!PurchaseTab)}>
                    <div className='h6 pt-1'>GRN Details</div>
                </div>
                <div className={`slide-content ${PurchaseTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="grnNo" className="form-label  pt-1 start">GRN No</label>
                                <input
                                    className="form-Input w-70"
                                    value={grnNo}
                                    disabled
                                />
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="catcode" className="form-label  pt-1 start">Delivery Date </label>
                                <input className='form-Input w-70' type='datetime-local'
                                    name="deliveryDate"
                                    min={getCurrentLocalDatetime()}
                                    value={formData.deliveryDate}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Location" className="form-label  pt-1 start">Location</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={selectedWareHouse}
                                    isDisabled={itemData?.eye === true ? true : false}
                                    onChange={handleLocationChange}
                                    options={WareHouse?.map((sup) => ({ value: sup, label: sup?.description }))}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Purchase Order No *</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    value={SelectedPO}
                                    isDisabled={itemData?.eye === true ? true : false}
                                    options={PurchaseOrder?.map((po) => ({ value: po.pOrderNo, label: po.pOrderNo }))}
                                    onChange={(selectedOption) => handlePoChange(selectedOption)}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="deliveryNote" className="form-label  pt-1 start">Delivery Note No</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    disabled={itemData?.eye === true ? true : false}
                                    id="deliveryNote"
                                    value={formData.deliveryNote}
                                    onChange={handleInputChange}
                                    name="deliveryNote"
                                />
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="TaxInvoice" className="form-label  pt-1 start">Tax Invoice No ( KRA )</label>
                                <input
                                    type="number" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-70"
                                    disabled={itemData?.eye === true ? true : false}
                                    id="TaxInvoice"
                                    value={formData.TaxInvoice}
                                    onChange={handleInputChange}
                                    name="TaxInvoice"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PurchaseOrderDate" className="form-label  pt-1 start">Purchase Order Date</label>
                                {itemData?.eye === true ?
                                    <input
                                        type="datetime" disabled
                                        className="form-Input w-70"
                                        id="PurchaseOrderDate"
                                        value={moment(formData.PurchaseOrderDate).format('DD-MMM-YYYY')}
                                        name="PurchaseOrderDate"
                                    /> :
                                    <input
                                        type="datetime-local"
                                        className="form-Input w-70"
                                        disabled={true}
                                        id="PurchaseOrderDate" min={getCurrentLocalDatetime()}
                                        value={formData.PurchaseOrderDate}
                                        onChange={handleInputChange}
                                        name="PurchaseOrderDate"
                                    />}
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="InvoiceNo" className="form-label  pt-1 start">Invoice No</label>
                                <input
                                    type="text" onWheel={(e) => e.target.blur()}
                                    className="form-Input w-70"
                                    id="InvoiceNo"
                                    disabled={itemData?.eye === true ? true : false}
                                    value={formData.InvoiceNo}
                                    onChange={handleInputChange}
                                    name="InvoiceNo"

                                />
                                <div className="valid-feedback">
                                    Looks good!
                                </div>
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Delivery Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={itemData?.eye === true ? true : false}
                                    options={DeliveryType}
                                    onChange={(selectedOption) => handleInputChange('inventoryAccountCode', selectedOption)}
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="inventoryAccountCode" className="form-label  pt-1 start">Supplier</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={true}
                                    value={SelectedSupplier}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="InvoiceDate" className="form-label  pt-1 start">Invoice Date</label>
                                {itemData?.eye === true ?
                                    <input
                                        type="datetime" disabled
                                        className="form-Input w-70"
                                        id="InvoiceDate"
                                        value={moment(formData.InvoiceDate).format('DD-MMM-YYYY')}
                                        name="InvoiceDate"
                                    /> :
                                    <input
                                        type="datetime-local" min={getCurrentLocalDatetime()}
                                        className="form-Input w-70"
                                        id="InvoiceDate"
                                        value={formData.InvoiceDate}
                                        onChange={handleInputChange}
                                        name="InvoiceDate"
                                    />
                                }
                            </div>
                            <div className="col d-flex justify-content-between gap-3">
                                <div className="col d-flex justify-content-between">
                                    <label htmlFor="Currency" className="form-label  pt-1 start">Currency</label>
                                    <Select
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 8,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                        className="w-70 p-0"
                                        isSearchable={false}
                                        isDisabled={itemData?.eye === true ? true : false}
                                        value={SelectedCurrency}
                                    />
                                </div>
                                <div className="col d-flex justify-content-between">
                                    <label htmlFor="EXRate" className="form-label  pt-1 start">EX Rate</label>
                                    <input
                                        type="number"
                                        className="form-Input w-70"
                                        disabled
                                        onWheel={(e) => e.target.blur()}
                                        id="exchangeRate"
                                        value={formData.exchangeRate}
                                        onChange={handleInputChange}
                                        name="exchangeRate"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section mb-2">
                <div className="d-flex mt-3 cursor-pointer slide-header gap-4"
                    onClick={() => setCostTab(!CostTab)}>
                    <div className='h6 pt-1'>Cost Center</div>
                </div>
                <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
                    <div className="border-box2 p-3">
                        <div className="form-group row pb-3">
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="PropertyGroup" className="form-label  pt-1 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={true}
                                    value={formData.costCenter1}
                                    onChange={handleDepartmentChange}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Property" className="form-label  pt-1 start">Unit</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={true}
                                    value={formData.costCenter2}
                                    onChange={handleDepartmentChange}
                                />
                            </div>
                            <div className="col d-flex justify-content-between">
                                <label htmlFor="Department" className="form-label  pt-1 start">Cost Center 3</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 8,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={true}
                                    value={formData.costCenter3}
                                    onChange={handleDepartmentChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row ">
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="Outlet" className="form-label  pt-1 start">Cost Center 4</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-70 p-0"
                                    isDisabled={true}
                                    value={formData.costCenter4}
                                    onChange={handleDepartmentChange}
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between">
                                <label htmlFor="remarks" className="form-label  pt-1 start">Remarks</label>
                                <input
                                    name="remarks"
                                    type='text'
                                    className="form-Input w-70"
                                    disabled={itemData?.eye === true ? true : false}
                                    id="remarks"
                                    value={formData.remarks}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col-1 px-5 mx-3'></div>
                            <div className="col-2 brderbox center" onClick={() => setAttachmentModal(true)} >
                                {'Attachment'}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`cost-center-section`} >
                <div className="mt-3 cursor-pointer slide-header">
                    <div className="nav nav-pills overslid d-flex gap-4">
                        {/* Nav tabs */}
                        <div
                            className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(0)}
                        >
                            Items
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Authorization
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Message
                        </div>
                        <div
                            className={`dashitems sidebar-text center  ${activeTab === 3 ? 'active' : ''}`}
                            onClick={() => handleTabClick(3)}
                        >
                            Additional Charges
                        </div>
                    </div>
                </div>
            </div>
            <div className={`slide-content open`}>
                <div className={`grid-1 border-box2 p-3`}>
                    {gridVisibility[0] && (
                        <UpdateItemGridGRN onRequisitionData={handleRequisitionData} itemData={POData} grnData={itemData} selectedPOData={selectedPOData}
                            currencyPrecision={currencyPrecision?.exp1 || 3} />
                    )}
                    {gridVisibility[1] && (
                        <AuthorizationGrn handleAuthorization={handleAuthorization}
                            usersDetails={usersDetails}
                            setUser={setUser}
                            itemData={POData} />
                    )}
                    {gridVisibility[2] && (
                        <div className="grid-3 border">
                            <MessageGrid handleMessage={handleMessage} />
                        </div>
                    )}
                    {gridVisibility[3] && (
                        <ItemGridGRN onRequisitionData={handleRequisitionData} />
                    )}
                </div>
            </div>
            <UpdateAttachment
                open={attachmentModal}
                rows={attachments}
                documentNo={grnNo}
                readOnly={itemData?.eye}
                onView={handleView}
                onFileSelect={handleFileSelect}
                onRemarkChange={handleRemarkChange}
                onDelete={handleDelete}
                previewImage={previewImage}
                previewOpen={previewModal}
                preview={preview}
                onClose={closeModal}
                closePreview={() => setPreviewModal(false)}
            />
        </div>
    )
}

export default UpdateGrn